import {
  LOADING_CATEGORIES,
  RECEIVE_CATEGORIES,
  LOADING_SUBMIT_CATEGORY,
  SUBMIT_CATEGORY_SUCCESS,
  CATEGORY_REQUEST_ERROR,
} from './actions';

const initialState = {
  list: [],
  isLoading: false,
  isLoadingSubmit: false,
  error: null,
};

export default function categories(state = initialState, action) {
  switch (action.type) {
    case LOADING_CATEGORIES:
      return {
        ...state,
        isLoading: true,
      };
    case RECEIVE_CATEGORIES:
      return {
        ...state,
        isLoading: false,
        list: action.categories,
      };
    case LOADING_SUBMIT_CATEGORY:
      return {
        ...state,
        isLoadingSubmit: true,
        error: null,
      };
    case SUBMIT_CATEGORY_SUCCESS:
      return {
        ...state,
        isLoadingSubmit: false,
        error: null,
      };
    case CATEGORY_REQUEST_ERROR:
      return {
        ...state,
        error: { ...action.error },
        isLoadingSubmit: false,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/categories/reducer.js